import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Usunięto nieużywany import useLocation
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import ListingDetails from './components/ListingDetails';
import CookieConsent from './components/Cookie';
import PolitykaPrywatnosci from './pages/PolitykaPrywatnosci';
import WarunkiKorzystania from './pages/WarunkiKorzystania';
import PolitykaCookies from './pages/PolitykaCookies';
import Services from './components/Services';
import Team from './components/Team';
import Contact from './components/Contact';
import Hero from "./components/Hero";
import NotFound from './components/NotFound';
import 'aos/dist/aos.css';

const HomePage = () => {
    return (
        <>
            <Hero />
            <Services />
            <Team />
            <Contact />
        </>
    );
};

const AppContent = () => {
    const [isCookieConsentVisible, setIsCookieConsentVisible] = useState(false);

    // ZMIANA: Usunięto nieużywaną stałą 'location'
    // const location = useLocation(); <-- TA LINIA ZOSTAŁA USUNIĘTA

    useEffect(() => {
        const savedPreferences = JSON.parse(localStorage.getItem('cookiePreferences'));
        if (!savedPreferences) {
            setIsCookieConsentVisible(true);
        }
    }, []);

    return (
        <>
            <Header />
            <ScrollToTop />
            <main>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/listing/:id" element={<ListingDetails />} />
                    <Route path="/polityka-prywatnosci" element={<PolitykaPrywatnosci />} />
                    <Route path="/warunki-korzystania" element={<WarunkiKorzystania />} />
                    <Route path="/polityka-cookies" element={<PolitykaCookies />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>
            <Footer />
            {isCookieConsentVisible && <CookieConsent setIsCookieConsentVisible={setIsCookieConsentVisible} />}
        </>
    );
};

const App = () => (
    <Router>
        <AppContent />
    </Router>
);

export default App;